if (!customElements.get('lc-indaba-story')) {
  customElements.define('lc-indaba-story', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const {signal} = this.controller;
      const dialog = this.querySelector('.li-lightbox');
      const zoom = this.querySelector('[data-li-zoom]');
      if (!dialog || !zoom) return;
      zoom.addEventListener('click', event => {
        if (typeof dialog.showModal !== 'function') return;
        event.preventDefault();
        const img = new Image();
        img.src = zoom.href;
        img.alt = zoom.querySelector('img')?.alt || '';
        dialog.querySelector('.li-lightbox__image').replaceChildren(img);
        dialog.showModal();
      }, {signal});
      dialog.addEventListener('click', event => {
        if (event.target.closest('[data-li-close]') || event.target === dialog) dialog.close();
      }, {signal});
      dialog.addEventListener('close', () => zoom.focus(), {signal});
      const film = this.querySelector('.li-film');
      const filmLink = this.querySelector('[data-li-film-open]');
      const video = this.querySelector('[data-li-film-video]');
      if (film && filmLink && video) {
        filmLink.addEventListener('click', event => {
          if (typeof film.showModal !== 'function') return;
          event.preventDefault();
          if (!video.getAttribute('src')) video.src = filmLink.href;
          video.muted = true;
          film.showModal();
          if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) video.play().catch(() => {});
        }, {signal});
        film.addEventListener('click', event => {
          if (event.target.closest('[data-li-film-close]') || event.target === film) film.close();
        }, {signal});
        film.addEventListener('close', () => { video.pause(); filmLink.focus(); }, {signal});
      }
      const variants = this.querySelector('[data-li-variants]');
      if (!variants) return;
      let data;
      try { data = JSON.parse(variants.textContent); } catch { return; }
      document.addEventListener('variant:change', event => {
        const variant = data.variants.find(item => String(item.id) === String(event.detail?.variant?.id));
        if (!variant) return;
        this.querySelectorAll('.li-hero__image,.li-texture__image').forEach(img => {
          img.removeAttribute('srcset');
          img.src = img.matches('.li-hero__image') ? (variant.hero || variant.image) : (variant.texture || variant.image);
          img.alt = variant.alt;
        });
        zoom.href = variant.texture || variant.image;
      }, {signal});
    }
    disconnectedCallback() { this.controller?.abort(); this.querySelector('[data-li-film-video]')?.pause(); }
  });
}
